var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodJob"},[_c('CommonHeader',{attrs:{"title":"goodJob"}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Good Job!')))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t("Let's move on")))])])])],1),_vm._v(" "),_c('CommonFooter')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9b6ed22","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/good-job/GoodJob.vue
// module id = 1636
// module chunks = 1